import { useContext, useState, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useTickets = () => {
  const { api, userID } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);

  const postRequest = useCallback(
    async (endpoint, body) => {
      if (!api) {
        console.error("Support API instance not found");
        return null;
      }

      const response = await api.post(endpoint, body);

      return response?.data;
    },
    [api]
  );

  // FETCH TICKETS
  const fetchTickets = async () => {
    try {
      setLoading(true);

      return await postRequest(
        "/Support/v1.0/getSupportTicket",
        {
          userid: userID || "",
        }
      );
    } catch (err) {
      console.error(
        "Fetch Tickets Error:",
        err?.response?.data || err
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  // FETCH CONVERSATION
  const fetchConversation = async (ticketid) => {
    try {
      return await postRequest(
        "/Support/v1.0/getSupportTicketConversation",
        {
          ticketid,
        }
      );
    } catch (err) {
      console.error(
        "Conversation Error:",
        err?.response?.data || err
      );
      return null;
    }
  };

  // SEND MESSAGE
  const sendMessage = async ({
    ticketid,
    message,
  }) => {
    try {
      return await postRequest(
        "/Support/v1.0/insertSupportTicketConversation",
        {
          ticketid,
          userid: userID || "",
          message,
          sender: "Client",
        }
      );
    } catch (err) {
      console.error(
        "Send Message Error:",
        err?.response?.data || err
      );
      return null;
    }
  };

  // RAISE TICKET
  const raiseTicket = async ({
    subject,
    description,
    department,
  }) => {
    try {
      return await postRequest(
        "/Support/v1.0/raiseSupportTicket",
        {
          ticketCode: "",
          subject,
          description,
          customerid: null,
          userid: userID || "",
          department,
        }
      );
    } catch (err) {
      console.error(
        "Raise Ticket Error:",
        err?.response?.data || err
      );
      return null;
    }
  };

  return {
    loading,
    fetchTickets,
    fetchConversation,
    sendMessage,
    raiseTicket,
  };
};

export default useTickets;